import {Amplify, Auth} from 'aws-amplify';
import {store} from './../app/store';
import {removeMe, setMe} from './../features/stores/user.slice';
import nonHookRequest from '../API/nonHookRequest';
import {envConfig} from './enviromentVariables';
import Cookies from 'js-cookie';
import {removeConfig, setConfig} from '../features/stores/config.slice';

interface ICheckOption {
  navigateAway?: boolean;
  checkSession?: boolean;
}
const urlParams = new URLSearchParams(window.location.search);
const codeUrl = urlParams.get("code");
Amplify.configure({
  Auth: {
    userPoolId: envConfig().userPoolId,
    region: 'eu-west-1',
    userPoolWebClientId: envConfig().userPoolWebClientId,
    authenticationFlowType: 'USER_PASSWORD_AUTH',
    oauth: {
      domain: envConfig().cognitoOauthDomain,
      scope: ['openid', 'aws.cognito.signin.user.admin'],
      redirectSignIn: `${envConfig().cognitoOauthSignin}${window.location.pathname == '/earnings/payment-methods' && codeUrl ? `/earnings/payment-methods?paypal-code=${codeUrl}` : ''}`,
      redirectSignOut: envConfig().cognitoOauthSignout,
      responseType: 'code', // or 'token', note that REFRESH token will only be generated when the responseType is code
    },
  }});

const checkLogin = async (options?:ICheckOption) => {
  let navigateAway; let checkSession;
  if (options) {
    navigateAway = options.navigateAway;
    checkSession = options.checkSession;
  }
  if (window.location.href.includes('bearerToken')) {
    const location = window.location.href.split('?bearerToken=');
    const token = `${location[1]
        .split('&')[0]
        .substring(0, location[1].split('&')[0].length - 1)
        .replace('#', '')}`;

    checkSession ? window.sessionStorage.setItem('token', token) : window.localStorage.setItem('token', token);
    if (navigateAway) window.history.pushState(null, '', '/');
    return true;
  } else if (checkSession ? sessionStorage.getItem('token') : localStorage.getItem('token')) {
    const result = await getSession(checkSession);
    return result;
  } else {
    return false;
  }
};

const getSession = async (checkSession: any, getToken?: boolean) => {
  try {
    const tokens: any = await Auth.currentSession();
    if (tokens && tokens.idToken) {
      checkSession ? window.sessionStorage.setItem('token', tokens.idToken.jwtToken) : window.localStorage.setItem('token', tokens.idToken.jwtToken);
    }
    return getToken ? tokens : true;
  } catch (error: any) {
    return false;
  }
};

const fetchMe = async () => {
  store.dispatch(setMe({me: null, loginStatus: 'FETCHING'}));
  const params = {}; // {fromAlfan: 'LINKS'};
  const request = await nonHookRequest({method: 'GET', url: '/user', params});
  if (request) {
    store.dispatch(setMe({me: request, loginStatus: 'LOGGED_IN'}));
  } else {
    // clear local and session storage
    // localStorage.clear();
    // sessionStorage.clear();
    store.dispatch(setMe({me: null, loginStatus: 'ERROR'}));
  }
};

const fetchConfig = async (params?: any) => {
  const request = await nonHookRequest({method: 'GET', url: '/api/v1/appConfig', params, isShortUrl: true});
  if (request) {
    store.dispatch(setConfig(request));
  } else {
    store.dispatch(removeConfig());
  }
};

const refreshMe = async (confirmation = false) => {
  const params = {}; // {fromAlfan: 'LINKS'};
  const request = await nonHookRequest({method: 'GET', url: '/user', params});
  if (request) {
    store.dispatch(setMe({me: request, loginStatus: 'LOGGED_IN'}));
    if (confirmation) {
      return true;
    }
  } else {
    // clear local and session storage
    localStorage.clear();
    sessionStorage.clear();
    store.dispatch(setMe({me: null, loginStatus: 'ERROR'}));
  }
};

const logOut = () => {
  store.dispatch(removeMe());
  localStorage.clear();
  sessionStorage.clear();
  logoutCognito();
};

// used when a user has an expired or invalid token and needs to log in again
const logOutUnauthenticated = () => {
  localStorage.clear();
  sessionStorage.clear();
  Auth.signOut();
  store.dispatch(setMe({me: null, loginStatus: 'ERROR'}));
  window.location.href = '/';
};

export interface ILogin {
  Bearer: string;
  navigateTo?: string;
}

const logoutCognito = async () => {
  try {
    await Auth.signOut();
    window.location.href = '/';
  } catch (error: any) {
    console.log('error logout', error);
  }
};

export {checkLogin, logOut, fetchMe, refreshMe, logOutUnauthenticated, getSession, fetchConfig};
